import { APP_INITIALIZER, ApplicationConfig,ErrorHandler,importProvidersFrom} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { routes } from './app.routes.js';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptorFn } from './core/interceptors/auth.interceptor.js';
import { NgxStripeModule } from 'ngx-stripe';
import * as Sentry from "@sentry/angular";
import { environment } from '../environments/environment.js';
import { provideServiceWorker } from '@angular/service-worker';
import { IconService } from './core/services/icon.service.js';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    importProvidersFrom(NgxStripeModule.forRoot(environment.stripeKey)),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptorFn])),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (iconService: IconService) => () => iconService.registerAllIcons(),
      deps: [IconService],
      multi: true,
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
